import type { ApiEnvelope } from '../../domain/types';
import type { HttpClientOptions, ProviderConnectionProbe, UserSettingsPublic } from './types';
import { createHttpTransport, type HttpTransport } from './httpTransport';
import { parseEnvelope } from './parseEnvelope';

export class HttpProviderOAuthClient {
  private readonly transport: HttpTransport;
  constructor(options: HttpClientOptions = {}) {
    this.transport = createHttpTransport(options);
  }
  async start(provider: ProviderOAuthProvider): Promise<ApiEnvelope<ProviderOAuthStart>> {
    const response = await this.transport.fetch(`/api/${provider}/oauth/start`);
    return parseEnvelope(response, undefined, `${provider.toUpperCase()}_OAUTH_HTTP_ERROR`);
  }
  async testConnection(
    provider: 'openai' | 'openai-codex' | 'gemini' | 'opencode-go',
  ): Promise<ApiEnvelope<ProviderConnectionProbe>> {
    const response = await this.transport.fetch(`/api/ai/connection/test/${provider}`, {
      method: 'POST',
    });
    return parseEnvelope(response, undefined, `${provider.toUpperCase()}_CONNECTION_HTTP_ERROR`);
  }
  async disconnect(provider: ProviderOAuthProvider): Promise<ApiEnvelope<UserSettingsPublic>> {
    const response = await this.transport.fetch(`/api/${provider}/oauth/disconnect`, {
      method: 'POST',
    });
    return parseEnvelope(
      response,
      undefined,
      `${provider.toUpperCase()}_OAUTH_DISCONNECT_HTTP_ERROR`,
    );
  }
}

export type ProviderOAuthProvider = 'slack' | 'github' | 'jira' | 'gmail';
export interface ProviderOAuthStart {
  authorizeUrl: string;
}
